module.exports = __webpack_public_path__ + "img/queenslander.8127eeaa.png";